function subscribeInputs() {
  $('.role_name').on('select2:select', function(e) {
    var selectInput = $(e.target);
    var selectId = selectInput.attr("id").split('_').slice(-2, -1)[0];
    var groupInput = $(`#user_kept_roles_attributes_${selectId}_group_id_input`);

    if (e.params.data.text == "super_admin") {
      groupInput.hide();
    }
    else {
      groupInput.show();
    }
  })

  $('input:checkbox').on('change', function(e) {
    var selectId = $(e.target).attr("id").split('_').slice(-3, -2)[0];
    var groupInput = $(`#user_kept_roles_attributes_${selectId}_group_id_input`);
    var nameInput = $(`#user_kept_roles_attributes_${selectId}_name_input`);

    if ($(e.target).prop("checked")) {
      groupInput.addClass("destroyed");
      nameInput.addClass("destroyed");
    }
    else {
      groupInput.removeClass("destroyed");
      nameInput.removeClass("destroyed");
    }
  })
}

function hideInputs() {
  var lockSuperAdmin = true;
  $('.role_name').each(function() {
    $(this).select2();
    var selectId = $(this).attr("id").split('_').slice(-2, -1)[0];
    var groupInput = $(`#user_kept_roles_attributes_${selectId}_group_id_input`);
    var deleteInput = $(`#user_kept_roles_attributes_${selectId}__destroy_input`);

    var val = $(this).select2('data')[0].text;

    if ((val == "super_admin") || val.length == 0) {
      groupInput.hide();

      if (val == "super_admin" && $(this).hasClass("persisted")) {
        deleteInput.hide();
        $(this).select2({disabled: lockSuperAdmin});
        lockSuperAdmin = false;
      }
    }
  })
}

function deviceConfigAutocomplete() {
  const specialValuesKeys = ["currency_exchange", "white_list_devices", "tax_rates", "tax_offices", "exchange_info"];

  let templateInput = $(`#device-config-template`);
  let keyInput = $(`#device-config-key`);
  let valueInput = $(`#device-config-value`);

  templateInput.on("change", () => {
    let templateInputValue = templateInput.val();

    if (templateInputValue !== ""){
      let formattedKeyInputValue = $(keyInput).data(templateInputValue);
      let formattedValueInputValue = $(valueInput).data(templateInputValue);

      keyInput.val(formattedKeyInputValue);
      specialValuesKeys.includes(formattedKeyInputValue) ? valueInput.val(JSON.stringify(formattedValueInputValue)) : valueInput.val(formattedValueInputValue);
    }
  });

  keyInput.on("change", () => {
    templateInput.val("").trigger("change");
  });
}

function taxOfficeAutocomplete() {
  let taxOffice = $(`#tax-office`);
  let taxOfficeVoivodeship = $(`#tax-office-voivodeship`);
  let taxOfficeCode = $(`#tax-office-code`);

  taxOfficeVoivodeship.on("change", () => {
    let taxOfficeValue = taxOfficeVoivodeship.val();
    let taxOfficeArray = taxOfficeCode.data('voivodeship-offices')[taxOfficeValue] || [];
    const currentTaxCode = taxOfficeCode.val();
    taxOfficeCode.find("option:not(:first)").remove();
    let newOptions = taxOfficeArray;

    newOptions.forEach(option => {
      const newOption = $("<option>").val(option['code']).text(option['name']);
      taxOfficeCode.append(newOption);
    });

    const availableCodes = newOptions.map(option => option['code']);
    if (!availableCodes.includes(currentTaxCode)) {
      taxOfficeCode.val('');
      taxOffice.val('');
    } else {
      taxOfficeCode.val(currentTaxCode);
    }
    taxOfficeCode.trigger("change");
  });

  taxOfficeCode.on("change", () => {
    const selectedIndex = taxOfficeCode[0].selectedIndex;
    if (selectedIndex !== -1) {
      const selectedOptionText = taxOfficeCode[0].options[selectedIndex].textContent;
      taxOffice.val(selectedOptionText);
    }
  });

  if (!taxOfficeVoivodeship.val()) {
    taxOfficeCode.val('');
    taxOffice.val('');
  }
  taxOfficeVoivodeship.trigger("change");
}

export {
  subscribeInputs,
  hideInputs,
  deviceConfigAutocomplete,
  taxOfficeAutocomplete,
};
